<form (ngSubmit)="onSave()" #usersList="ngForm">
	<div class="main-wrapper">
		<div class="select-info">
			<label class="text-right">{{ selectedDesc }}</label>
		</div>
		<div class="table-wrapper">
			<mat-table class="table user-list-table" [dataSource]="dataSource" matSort matSortActive="FullName" matSortDirection="asc"
				matSortDisableClear>
				<ng-container matColumnDef="UserName">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						<span class="column-text">User Name</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.UserName }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="FullName">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						<span class="column-text">Full Name</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.FullName }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="Selected">
					<mat-header-cell *matHeaderCellDef>
						<mat-checkbox class="bs-checkbox" aria-label="Select all users" title="Select All" [name]="selectAll"
							[(ngModel)]="allUsersSelected" [ngModelOptions]="{ standalone: true }" (change)="checkAllUsers()"
							[disabled]="dataSource?.data?.length === 0">
						</mat-checkbox>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						<mat-checkbox class="bs-checkbox" [name]="'selected-' + user.Id" [(ngModel)]="user.Selected"
							(change)="checkIfAllUsersSelected()">
						</mat-checkbox>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
			</mat-table>

			<shared-no-data-available *ngIf="dataSource.data.length === 0 && isDataLoaded"></shared-no-data-available>
		</div>

		<div class="save-cancel-wrapper">
			<div>
				<button class="btn btn-cancelSave" type="button" (click)="onCancel()">
					CANCEL
				</button>
			</div>
			<div>
				<button class="btn btn-save pull-right" type="submit" [disabled]="!usersList.dirty">
					SAVE
				</button>
			</div>
		</div>
	</div>
</form>
